import { NicknameGeneratorConfig } from '@/types/feedback';

export const NICKNAME_CONFIG: NicknameGeneratorConfig = {
  animeHeroes: [
    'Naruto',
    'Luffy',
    'Goku',
    'Saitama',
    'Eren',
    'Mikasa',
    'Levi',
    'Tanjiro',
    'Deku',
    'Light',
  ] as const,

  lolChampions: [
    'Ziggs',
    'Ahri',
    'Jinx',
    'Yasuo',
    'Lux',
    'Zed',
    'Lee Sin',
    'Teemo',
    'Vi',
    'Kaisa',
    'Jhin',
  ] as const,

  techPrefixes: ['Tech', 'Code', 'Web', 'Dev', 'Byte', 'Pixel'] as const,

  techSuffixes: [
    'Ninja',
    'Wizard',
    'Master',
    'Explorer',
    'Hero',
    'Legend',
  ] as const,
};

export const BRAND_COLORS = {
  blue: '#2563EB',
  indigo: '#4F46E5',
  purple: '#7C3AED',
  pink: '#DB2777',
  emerald: '#059669',
} as const;
